import { cn } from '@/lib/utils'

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label="Cargando"
      className={cn('animate-pulse rounded-md bg-surface-200 dark:bg-[#252f3a]', className)}
      {...props}
    />
  )
}
